import script from "./OrderActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderActions.vue?vue&type=script&setup=true&lang=ts"

import "./OrderActions.vue?vue&type=style&index=0&id=6ec8751e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec8751e"]])

export default __exports__